import useTranslate from 'lib/languages/useTranslate';
import SectionTitle from '../../../../shared/generic/sectionTitle/presentational/SectionTitle';
import DataCheck from '../../../../shared/generic/dataCheck/presentational/DataCheck';
import { formatMoney } from 'lib/utils';
import PendingTransactionListItem from './PendingTransactionListItem';
import dayjs from 'dayjs';
import PageContainer from '../../../../shared/generic/pageContainer/presentational/PageContainer';
import { useGetPendingTransactionsQuery } from 'lib/services';

const PendingTransactionsList = () => {
    const translate = useTranslate('pendingTransactions');

    const {
        data: pendingTransactions,
        isFetching,
    } = useGetPendingTransactionsQuery(undefined, {
        pollingInterval: 60000,
    });

    const pendingTransactionsAmount = pendingTransactions?.totalAmountPending;
    
    return (
        <PageContainer className="transactions-container">
            <SectionTitle title={translate('breadcrumbText')} backRoute="/" />

            <DataCheck data={pendingTransactions?.items} isLoading={isFetching}>
                <section className="transactions-scroll-container">
                    <SectionTitle title={translate('titleText')} secondary />

                    <h2 className="amount">{`Amount: ${
                        pendingTransactionsAmount < 0 ? '-' : ''
                    }£${formatMoney(pendingTransactionsAmount).substring(
                        1,
                    )}`}</h2>

                    {pendingTransactions?.items.map((transaction, index) => (
                        <PendingTransactionListItem
                            key={transaction.createdDate}
                            item={transaction}
                            keyIndex={`${dayjs(
                                transaction.createdDate,
                            ).format()}-${index}`}
                        />
                    ))}
                </section>
            </DataCheck>
        </PageContainer>
    );
};

export default PendingTransactionsList;
